import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { permisA2Data } from '../../data/pillars/permisA2';

export default function PillarPermisA2() {
  return <PillarPageTemplate data={permisA2Data} />;
}
